import React from "react"
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Input,
  Label,
} from "reactstrap"
import Swal from "sweetalert2"

const HolidayModal = ({
  open,
  toggle,
  selectedHoliday,
  setSelectedHoliday,
  viewOnly,
  onSubmit,
}) => {
  const handleSubmit = () => {
    const { date, reason } = selectedHoliday || {}

    if (!date) {
      return Swal.fire("Required", "Please select Holiday Date", "warning")
    }

    if (!reason || !reason.trim()) {
      return Swal.fire("Required", "Please enter Holiday Reason", "warning")
    }

    if (isNaN(new Date(date).getTime())) {
      return Swal.fire("Invalid Date", "Please select a valid date", "warning")
    }

    onSubmit()
  }

  return (
    <Modal isOpen={open} centered>
      <ModalHeader toggle={toggle}>
        {viewOnly
          ? "View Holiday"
          : selectedHoliday?.id
          ? "Edit Holiday"
          : "Add Holiday"}
      </ModalHeader>

      <ModalBody>
        <Label>
          Date <span className="text-danger">*</span>
        </Label>
        <Input
          type="date"
          value={selectedHoliday?.date || ""}
          disabled={viewOnly}
          onChange={e =>
            setSelectedHoliday(prev => ({
              ...prev,
              date: e.target.value,
            }))
          }
          className="rounded-4 mb-3"
        />

        <Label>
          Reason <span className="text-danger">*</span>
        </Label>
        <Input
          type="textarea"
          placeholder="Enter holiday reason"
          value={selectedHoliday?.reason || ""}
          disabled={viewOnly}
          onChange={e =>
            setSelectedHoliday(prev => ({
              ...prev,
              reason: e.target.value,
            }))
          }
          className="rounded-4"
        />
      </ModalBody>

      {!viewOnly && (
        <ModalFooter>
          <Button className="btn-blue" onClick={handleSubmit}>
            Submit
          </Button>
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>
        </ModalFooter>
      )}
    </Modal>
  )
}

export default HolidayModal
